import { Github, Twitter, Brain, Heart } from "lucide-react";
import { Link } from "react-router-dom";

const footerLinks = {
  Products: [
    { label: "Library", href: "/library" },
    { label: "Server", href: "/server" },
    {
      label: "GitHub",
      href: "https://github.com/mzhub/cortex",
      external: true,
    },
  ],
  Resources: [
    { label: "Getting Started", href: "/library/getting-started" },
    { label: "API Reference", href: "/library/api" },
    { label: "Integration Guide", href: "/server/integration" },
  ],
  Company: [
    { label: "MZ Hub", href: "https://mzhub.dev", external: true },
    { label: "About", href: "https://mzhub.dev/about", external: true },
    { label: "Contact", href: "https://mzhub.dev/contact", external: true },
  ],
};

export default function Footer() {
  return (
    <footer className="border-t border-cortex-border bg-cortex-bg-dark/50 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-cortex-primary to-cortex-accent flex items-center justify-center">
                <Brain size={18} className="text-black" />
              </div>
              <span className="font-bold text-xl text-cortex-text-primary">
                Cortex
              </span>
            </Link>
            <p className="text-cortex-text-secondary text-sm leading-relaxed">
              Persistent memory for AI agents. The digital brain that never
              forgets.
            </p>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-semibold text-cortex-text-primary mb-4">
                {category}
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.href}>
                    {link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-cortex-text-secondary hover:text-cortex-primary transition-colors"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        className="text-sm text-cortex-text-secondary hover:text-cortex-primary transition-colors"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-cortex-border pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-cortex-text-muted text-sm flex items-center gap-1">
            Built with <Heart size={14} className="text-cortex-error" /> by{" "}
            <a
              href="https://mzhub.dev"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cortex-primary hover:underline"
            >
              MZ Hub
            </a>
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://github.com/mzhub/cortex"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cortex-text-muted hover:text-cortex-primary transition-colors"
            >
              <Github size={20} />
            </a>
            <a
              href="https://twitter.com/mzhub"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cortex-text-muted hover:text-cortex-primary transition-colors"
            >
              <Twitter size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
